(() => {
  if (window.__hfGiftFinderCoreLoaderV9) return;
  window.__hfGiftFinderCoreLoaderV9 = true;

  const current = document.currentScript;
  if (!current?.src) return;

  // Restore saved answers only once every question and matching rule is installed.
  window.__hfGiftFinderLayersReady = false;
  const notices = new Map();
  document.querySelectorAll('gift-finder').forEach((finder) => {
    finder.inert = true;
    finder.setAttribute('aria-busy', 'true');
    const notice = document.createElement('div');
    notice.className = 'hf-gf__startup-status page-width';
    notice.setAttribute('role', 'status');
    notice.textContent = finder.dataset.hfStartupLoading || finder.dataset.loadingLabel;
    finder.before(notice);
    notices.set(finder, notice);
  });
  const failed = () => {
    notices.forEach((notice, finder) => {
      notice.replaceChildren();
      const message = document.createElement('p');
      message.textContent = finder.dataset.hfStartupError || finder.dataset.errorLabel;
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.textContent = finder.dataset.hfRetry;
      retry.addEventListener('click', () => window.location.reload());
      const browse = document.createElement('a');
      browse.href = finder.dataset.sourceUrl;
      browse.textContent = finder.dataset.hfBrowseGifts;
      notice.append(message, retry, browse);
      finder.removeAttribute('aria-busy');
    });
  };
  const ready = () => {
    window.__hfGiftFinderLayersReady = true;
    document.querySelectorAll('gift-finder').forEach((finder) => {
      finder.initialUrlRestoreComplete = false;
      finder.beginInitialUrlRestore?.();
      Promise.resolve(finder.initialUrlRestorePromise).finally(() => {
        finder.dataset.hfJourneyReady = 'true';
        finder.inert = false;
        finder.removeAttribute('aria-busy');
        notices.get(finder)?.remove();
        if (document.activeElement === document.body) finder.focusForOwnHash?.();
        finder.scheduleRouteLoad?.();
        finder.dispatchEvent(new Event('hf:journey-ready'));
      });
    });
  };

  let assetUrls = {};
  try {
    assetUrls = JSON.parse(current.dataset.hfAssetUrls || '{}');
  } catch (error) {
    assetUrls = {};
  }
  const assetUrl = (filename) => {
    const url = new URL(assetUrls[filename] || filename, current.src);
    if (!url.search) url.search = new URL(current.src).search;
    return url.href;
  };
  const load = (filename, onLoad) => {
    const script = document.createElement('script');
    script.src = assetUrl(filename);
    if (current.nonce) script.nonce = current.nonce;
    if (onLoad) script.addEventListener('load', onLoad, { once: true });
    script.addEventListener('error', failed, { once: true });
    document.head.appendChild(script);
  };

  const loadV2 = () => load('hf-gift-finder-v2.js', () => {
    load('hf-gift-finder-v2-gift-styles.js', () => {
      load('hf-gift-finder-v2-occasions.js', () => {
        load('hf-gift-finder-v2-adaptive.js', () => {
          load('hf-gift-finder-v2-results.js', () => {
            load('hf-gift-finder-v2-broadening.js', () => {
              load('hf-gift-finder-v2-ranking.js', () => {
                load('hf-gift-finder-v2-persistence.js', () => {
                  load('hf-gift-finder-v2-experience.js', () => {
                    load('hf-gift-finder-v2-experience-stability.js', () => {
                      load('hf-gift-finder-v2-taxonomy.js', () => {
                        load('hf-gift-finder-v2-reason.js', () => {
                          load('hf-gift-finder-v2-runtime-state.js', () => {
                            load('hf-gift-finder-v2-no-dead-ends.js', ready);
                          });
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
  });
  // All viewports use the same current product data, not stale desktop route counts.
  const loadRouteLayer = () => {
    load('hf-gift-finder-live-index.js', () => {
      load('hf-gift-finder-route-fix.js', loadV2);
    });
  };

  load('hf-gift-finder-core-impl.js', () => {
    load('hf-gift-finder-route-bridge.js', loadRouteLayer);
  });
})();
